"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./DropdownList.css");
var Utils = require("player-core/utils");
var DropdownList = (function (_super) {
    __extends(DropdownList, _super);
    function DropdownList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: _this.props.value
        };
        _this._onChange = _this._onChange.bind(_this);
        return _this;
    }
    DropdownList.prototype._onChange = function (event) {
        var value = event.target.value;
        this.setState({
            value: value
        });
        this.props.onChange && this.props.onChange(value);
    };
    DropdownList.prototype.componentWillReceiveProps = function (props) {
        if (this.props.value !== props.value) {
            this.setState({
                value: props.value
            });
        }
    };
    DropdownList.prototype.render = function () {
        var cssOuter = ['p-dropdownlist', 'form-row'];
        cssOuter.push('width-' + this.props.width.toLowerCase());
        if (this.props.isRequired) {
            cssOuter.push('is-required');
        }
        if (!this.props.isEnabled) {
            cssOuter.push('is-disabled');
        }
        if (this.props.errorMessage) {
            cssOuter.push('is-invalid');
        }
        var accessibilityAttr = {};
        if (!this.props.showLabel) {
            accessibilityAttr['aria-label'] = this.props.label;
        }
        if (this.props.ariaLabelledBy && !this.props.label) {
            accessibilityAttr['aria-labelledby'] = this.props.ariaLabelledBy;
        }
        var classes = ['default', 'p-bc-f-blue50', 'p-bg-hv-white'];
        if (this.props.errorMessage == '') {
            classes.push('p-bc-grey60');
        }
        else {
            classes.push('p-bc-error50');
        }
        return (React.createElement("div", { className: cssOuter.join(' ') },
            this.props.showLabel && this.props.label &&
                React.createElement("label", { htmlFor: this.props.id },
                    this.props.label,
                    this.props.isRequired && React.createElement("span", { className: "p-t-error50" }, "*")),
            React.createElement("div", { className: "p-dropdown-list-wrapper" },
                React.createElement("select", __assign({ id: this.props.id }, accessibilityAttr, { "data-tag": this.props.tag, name: this.props.name, value: this.state.value, onChange: this._onChange, disabled: !this.props.isEnabled, className: classes.join(' ') }), this.props.items.length && this.props.items.map(function (item) { return React.createElement("option", { key: item.value, value: item.value }, item.label); })),
                React.createElement("span", { className: "p-icon-down-triangle" })),
            this.props.errorMessage &&
                React.createElement("p", { className: 'error p-t-error50' }, this.props.errorMessage)));
    };
    return DropdownList;
}(React.Component));
DropdownList.defaultProps = {
    id: 'idp' + Utils.createUUID(),
    tag: null,
    label: null,
    name: null,
    width: "Block",
    value: "",
    showLabel: true,
    items: [],
    isRequired: false,
    isEnabled: true,
    ariaLabelledBy: null,
    errorMessage: ""
};
exports.DropdownList = DropdownList;
if (typeof csod == 'object' && csod.engine) {
    if (!csod.engine.controls['editor-controls'])
        csod.engine.controls['editor-controls'] = {};
    csod.engine.controls['editor-controls']['DropdownList'] = DropdownList;
}

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["DropdownList"] = undefined;


//////////////////
// WEBPACK FOOTER
// ../player-editor-controls/controls/DropdownList/index.js
// module id = 561
// module chunks = 0